import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";

import { AuthProvider } from "./contexts/AuthContext";
import { BarNotificationProvider } from "./contexts/BarNotificationContext";
import { MultiMarketProvider } from "./contexts/MultiMarketContext";
import router from "./utils/router";
import { store } from "./utils/store";

function App() {
	return (
		<Provider store={store}>
			<AuthProvider>
				<MultiMarketProvider>
					<BarNotificationProvider>
						<RouterProvider router={router} />
					</BarNotificationProvider>
				</MultiMarketProvider>
			</AuthProvider>
		</Provider>
	);
}

export default App;
